import React, { useState, useEffect } from 'react';
import Topbar from '../layouts/Topbar';
import Grid from "@mui/material/Grid2";
import Image from "../../Utils/getImage";
import { Button, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";
import instance from '../../Utils/api';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import SubOrder_details from '../components/subOrder_details';

const SubOrder_info = () => {
    const { order_id } = useParams(); // Get order ID from URL
    const [adminId, setadminId] = useState('')
    const [deadline, setDeadline] = useState(null);
    const [status, setstatus] = useState('');
    const [amount, setAmount] = useState(null);
    const [documents, setDocuments] = useState(null);
    const [finalImage, setFinalImage] = useState(null);
    const [suborderDetails, setsuborderDetails] = useState([]);
    const [juniorAdmins, setJuniorAdmins] = useState([]);
    const [seniorAdmins, setSeniorAdmins] = useState([]);
    const [orderAdminId, setOrderAdminId] = useState('');
    const [paymentAmount, setpaymentAmount] = useState('')
    const [staff, setStaff] = useState([])

    //fetch admins
    const fetchadmins = async () => {
        try {
            const response = await instance.get('/Admin/getAdmins')

            // Filter Junior Designers
            const juniorFilter = response?.data?.data?.filter(admin => admin.role === 'JuniorDesigner');
            const juniorFormatted = juniorFilter?.map((employee, index) => ({
                sno: index + 1,
                employeeName: employee?.name,
                employeeId: employee?._id,
                employeeImage: employee?.profile_pic
            }));

            // Filter Senior Designers
            const seniorFilter = response?.data?.data?.filter(admin => admin.role === 'SeniorDesigner');
            const seniorFormatted = seniorFilter?.map((employee, index) => ({
                sno: index + 1,
                employeeName: employee?.name,
                employeeId: employee?._id,
                employeeImage: employee?.profile_pic
            }));

            setJuniorAdmins(juniorFormatted);
            setSeniorAdmins(seniorFormatted);
        }
        catch (error) {
            console.log("error to fetch admins:", error.message)
        }

    }

    //fetch admins
    const fetchStaff = async () => {
        try {
            const response = await instance.get('/Staff/getStaff');
            // console.log("formatteddata", response);

            const formatteddata = response?.data?.data?.map((employee, index) => ({
                sno: index + 1,
                staffId: employee?._id,
                Name: employee?.Name,
                Designation: employee?.Designation.Designation,
                DesignationName: employee?.Name,
            }))
            setStaff(formatteddata);
        }
        catch (error) {
            console.log("error to fetch staff:", error.message)
        }

    }

    useEffect(() => {
        fetchadmins();
        fetchStaff()
    }, [])


    const fetchSubOrderDetailsById = async () => {
        try {
            const response = await instance.get(`/Order/SubOrderById?order_id=${order_id}`);
            setsuborderDetails(response?.data?.data); // Set fetched data to state
        } catch (error) {
            console.error("Error fetching suborder details:", error.message);
        }
    };

    // Fetch suborder details by ID
    useEffect(() => {
        fetchSubOrderDetailsById();
    }, [order_id]);

    // console.log(suborderDetails);

    useEffect(() => {
        setOrderAdminId(suborderDetails?.assigned_to?._id)
    }, [suborderDetails])
    return (
        <>
            <Topbar />
            <section className='order-info-section'>
                <div className='order-info'>
                    <div className="add-employee-title">
                        <Typography>Order Info</Typography>
                        <Typography variant='h5'>Customer Details</Typography>
                    </div>
                    <Grid
                        container
                        spacing={2}
                    // sx={{
                    //     display: "flex",
                    //     justifyContent: "flex-start",
                    //     alignItems: "flex-start",
                    // }}
                    >
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                            <div className="add_emloyee-upload-file">
                                <Image src={suborderDetails?.customer_id?.profile_pic} alt="profile_pic" width={220} height={171} />
                            </div>
                        </Grid>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                            <div className="add_emloyee-content">
                                <div className="add_emloyee-content-text-2">
                                    <Typography variant="h5">Name</Typography>
                                    <Typography>{suborderDetails?.customer_id?.name}</Typography>
                                </div>
                                <div className="add_emloyee-content-text-2">
                                    <Typography variant="h5">Address</Typography>
                                    <Typography>{suborderDetails?.customer_id?.location}</Typography>
                                </div>
                                <div className="add_emloyee-content-text-2">
                                    <Typography variant="h5">Mobile number</Typography>
                                    <Typography>{suborderDetails?.customer_id?.mobile}</Typography>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <div className="order-details-title">
                    <Typography variant='h5'>Order Details</Typography>
                </div>
                <>
                    <Grid container>
                        <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                            <SubOrder_details subOrder={suborderDetails} juniorAdmins={juniorAdmins} fetchSubOrderDetailsById={fetchSubOrderDetailsById} staff={staff} role={"JuniorDesigner"} />
                        </Grid>
                    </Grid>
                </>
            </section>
        </>
    )
}

export default SubOrder_info;